/**
 * 富文本相关业务工具方法
 */

// 高亮坐标转换
export const rebuildHighlight = (list) => {
  return (
    list?.map((item) => ({
      position: [item.startPos, item.endPos],
    })) ?? []
  );
};
